import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ColegiosService } from '../services/colegios.service';
import { CursosService } from '../services/cursos.service';
import { ClasesService } from '../services/clases.service';
import { UserService } from '../services/user.service';
import { LicenciaService } from '../services/licencia.service';
import { AuthenticationService } from '../services/authentication.service';
import { auth } from 'firebase';
import { Router } from '@angular/router';
import { ExcelService } from '../services/excel.service';

import * as XLSX from 'xlsx';
import { ChatService } from '../services/chat.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-test123',
  templateUrl: './test123.component.html',
  styleUrls: ['./test123.component.css'],
})
export class Test123Component implements OnInit {
  correos = [];

  cursos: any = [];
  clases: any = [];
  numerofinal: number = 0;
  numeroinicial: number = 0;
  codigos: any = [];
  codigosNoEstan: any = [];
  uids = [];

  licencias: any = [
    'MSHRQ-10000-69886-66293',
    'MSHRQ-10001-59977-89671',
    'MSHRQ-10002-12780-11052',
    'MSHRQ-10003-50689-75291',
    'MSHRQ-10004-27135-39032',
    'MSHRQ-10005-22183-87046',
    'MSHRQ-10006-10622-42967',
    'MSHRQ-10007-49190-90763',
    'MSHRQ-10008-61827-11655',
    'MSHRQ-10009-69344-71348',
    'MSHRQ-10010-54277-94562',
    'MSHRQ-10011-28915-75055',
    'MSHRQ-10012-16852-15199',
    'MSHRQ-10013-93053-92219',
    'MSHRQ-10014-42415-25701',
    'MSHRQ-10015-73981-20625',
    'MSHRQ-10016-77024-14551',
    'MSHRQ-10017-84160-55442',
    'MSHRQ-10018-68269-53529',
    'MSHRQ-10019-99051-42310',
    'MSHRQ-10020-57521-16188',
    'MSHRQ-10021-29252-46717',
    'MSHRQ-10022-64154-98023',
    'MSHRQ-10023-72640-80632',
    'MSHRQ-10024-50802-10928',
    'MSHRQ-10025-75660-59090',
    'MSHRQ-10026-78094-89241',
    'MSHRQ-10027-40669-76293',
    'MSHRQ-10028-17515-77540',
    'MSHRQ-10029-68725-44305',
  ];

  codigosUsuarios = [];

  usuariosUid: any = [];
  usuarios: any = [];
  listadoUsuariosColegia: any = [];
  datos: any[] = [];
  usuariosValidos = [];
  usuariosNoValidos = [];
  viajosEmail: any = [];
  actualesEmail: any = [];
  mostrar = false;
  usuariosAntiguos = [];
  constructor(
    private http: HttpClient,
    private colegiosService: ColegiosService,
    private cursosService: CursosService,
    private clasesService: ClasesService,
    private chatService: ChatService,
    private usuariosService: UserService,
    private licenciasService: LicenciaService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {
    // this.getUsuariosCole();
    // this.uids.push('3SPvJoqsVNRpHnFUUfWK9zp4JJY2');
    // this.buscarCursos()
  }

  verChatQueIdContengaString() {
    this.chatService
      .getIdsContainingSubstring('HXLguHX3wtRJbzQvoEMnASP6DU82')
      .subscribe((ids) => {
        console.log('IDs que contienen:', ids);
      });
  }

  async recogerDatosAlumnos() {
    try {
      const colegio = 'qKQCtDaQ5GRP8wsJVVsi';
      const snapshot = await this.usuariosService
        .getUserByColegioAndRole(colegio)
        .toPromise();
      if (snapshot.empty) {
        console.log('No se encontraron usuarios.');
        return;
      }
      const users: any[] = await Promise.all(
        snapshot.docs.map(async (doc) => {
          const userData: any = doc.data();
          // console.log('User Data:', userData);  // Verificar datos obtenidos
          if (userData.clases) {
            // userData.classNames = await this.clasesService.getClassNames(userData.clases);
            const classNames = await this.clasesService.getClassNames(
              userData.clases
            );
            userData.classNames = classNames.join(', '); // Convertir array a string separado por comas
          }
          if (userData.fechanac && userData.fechanac.toDate) {
            userData.fechanac = userData.fechanac.toDate();
          }
          return userData;
        })
      );
      if (users.length === 0) {
        console.log('No hay usuarios para exportar.');
        return;
      }
      console.log('Usuarios obtenidos:', users); // Verificar datos finales
      this.excelService.exportAsExcelFile(users, 'Users');
    } catch (error) {
      console.error('Error exporting users:', error);
    }
  }

  cambiarFinal(num) {
    this.numerofinal = num;
  }

  getUsers() {
    this.uids.forEach((uid) => {
      this.usuariosService.getUserById(uid).subscribe((user) => {
        if (user.length > 0) {
          var usuario = user[0].payload.doc.data();
          this.usuarios.push(usuario);
        }
      });
    });
  }

  getUsersByCodigo() {
    this.usuarios = [];
    this.codigosUsuarios.forEach((codigo) => {
      this.usuariosService.getUserCodigo(codigo).subscribe((user) => {
        if (user.size > 0) {
          var usuario: any = user.docs[0].data();
          console.log('usuario con código: ' + codigo, usuario.uid);
          this.usuarios.push(usuario.uid);
        }
      });
    });
  }

  // getUsuariosPorLista() {
  //   let emails = [

  //   ];
  //   // let emailsBuenos = [];
  //   emails.forEach((email) => {
  //     let emailBueno =""
  //     if (!email.includes('@')) {
  //       emailBueno = email + '@ais.colegia.org'
  //     } else {
  //       emailBueno = email
  //     }
  //     this.usuariosService.getUserByEmail(emailBueno).subscribe((usuarios:any) => {
  //       let usuario = usuarios.docs[0].data();
  //       console.log("EMAIL:" + usuario.email)
  //       console.log(usuario.uid)
  //       this.uids.push(usuario.uid)
  //     });
  //   });

  //   // console.log(emailsBuenos);

  // }

  getUsuariosCole(): void {
    const cole = 'qKQCtDaQ5GRP8wsJVVsi';

    this.usuariosService
      .getUserColegio(cole)
      .pipe(take(1)) // 🔹 Se ejecuta una sola vez
      .subscribe({
        next: (usuarios) => {
          const uidsSet = new Set<string>();

          usuarios.forEach((usuario: any) => {
            const email = usuario.data().username;
            const uid = usuario.data().uid;

            const esExcluido =
              email.includes('@academica') ||
              email.includes('laiatech') ||
              email.includes('gofacing') ||
              email.includes('thecampus');

            if (!esExcluido) {
              //De 500 en 500 porque es lo que puede procesar Firebase en el back antes de dar error
              if (uidsSet.size < 500) uidsSet.add(uid); // 🔹 Evita duplicados automáticamente
            } else {
              console.log('Excluido:', email);
            }
          });

          this.uids = Array.from(uidsSet); // 🔹 Convertimos el Set a array
          console.log('Total únicos:', this.uids.length);
        },

        error: (err) => {
          console.error('Error al obtener usuarios:', err);
        },
      });
  }

  // getUsuariosCole() {
  //   const cole = 'qKQCtDaQ5GRP8wsJVVsi';
  //   this.usuariosService.getUserColegio(cole).subscribe((usuarios) => {
  //     console.log('val', usuarios.size);
  //     usuarios.forEach((usuario: any) => {
  //       // console.log(usuario.data().uid)
  //       if (
  //         usuario.data().username.includes('@academica') ||
  //         usuario.data().username.includes('laiatech') ||
  //         usuario.data().username.includes('gofacing') ||
  //         usuario.data().username.includes('thecampus')
  //       ) {
  //         console.log(usuario.data().username);
  //       } else {
  //         this.uids.push(usuario.data().uid);
  //       }
  //       // var valor = {
  //       //   codigo: usuario.data().code,
  //       //   usuario: usuario.data().username,
  //       //   nombre: usuario.data().name,
  //       //   apellidos: usuario.data().last_name,
  //       //   emailpersonal: usuario.data().email,
  //       //   tipo:usuario.data().role,
  //       //   colegio: usuario.data().courses[0].nombre,
  //       // };
  //       // this.listadoUsuariosColegia.push(valor);
  //       // console.log("valor",valor)
  //     });
  //     console.log(this.uids.length);
  //   });
  // }

  //files xlsx
  fileChangeEvent(event: any): void {
    this.datos = [];
    var datosXLSX = null;
    datosXLSX = this.excelService.importAsExcelFile(event);
    setTimeout(() => {
      let onload = this.onload(datosXLSX.result);
      this.datos = onload;
      console.log('DATOS', this.datos);
    }, 2000);
  }

  onload(e) {
    const binarystr: string = e;
    const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

    /* selected the first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    /* save data */
    const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
    return data;
  }

  comprobacion() {
    console.log(this.datos.length);
    console.log(this.datos);
    this.datos.forEach((dato) => {});
  }

  guardar() {
    this.datos.forEach((dato) => {
      console.log(dato);
      if (dato.email) {
        this.actualesEmail.push(dato.email);
      }
      if (dato.email_viejos) {
        this.viajosEmail.push(dato.email_viejos);
      }
    });
  }
  comprobar() {
    console.log(this.actualesEmail);
    console.log('2--------------------');
    console.log(this.viajosEmail);
    console.log('--------------------');
    this.actualesEmail.forEach((element) => {
      if (this.viajosEmail.includes(element)) {
        this.usuariosAntiguos.push(element);
        console.log(element);
      }
    });
  }

  verViejos() {
    this.mostrar = true;
    console.log(this.usuariosAntiguos);
  }

  comprobarSalasConUsuarios() {
    this.usuariosValidos = [];
    this.usuariosNoValidos = [];
    this.datos.forEach((dato) => {
      this.usuariosService.getUserByUsuario(dato.name).subscribe((usuario) => {
        if (!usuario.empty) {
          let usuarioId = usuario.docs[0].id;
          console.log(
            'Existe el usuario ' + dato.name + ' con ID: ' + usuarioId
          );
          this.usuariosValidos.push(dato.name);
        } else {
          this.usuariosNoValidos.unshift(dato.name);
        }
      });
    });
    setTimeout(() => {
      console.log(this.usuariosNoValidos.length);
      console.log(this.usuariosNoValidos);
    }, 30000);
  }

  crearSalas() {
    var usuarios = [];

    // let usuariosTest = [
    //   'sergiomartin@escolapiosemaus.org',
    //   'direccion@alminar.es',
    // ];
    for (let index = 0; index < usuarios.length; index++) {
      const email = usuarios[index];
      console.log('index', index);
      this.usuariosService.getUserByEmail(email).subscribe((usuarios: any) => {
        if (usuarios.docs.length > 0) {
          let datos = usuarios.docs[0].data();
          console.log('datos: ', datos);
          this.crearSala(datos);
        }
      });
    }
  }

  crearSala(datos) {
    var dataTrans = {
      codigo: datos.codigo,
      nombre: datos.name,
      apellidos: datos.last_name,
      cole: datos.cursos[0].nombre,
      email: datos.email,
    };
    var jsonbody = JSON.stringify(dataTrans);

    const url =
      'https://us-central1-the-campus-56b06.cloudfunctions.net/app/crearSalaEnPexip';
    fetch(url, {
      method: 'POST',
      body: jsonbody,
    })
      .then((response) => response.text())
      .then((data) => {
        console.log('crada sala: ', datos.email);
      });
  }

  salasEliminar() {
    // this.usuariosNoValidos=[
    // ]
    // this.borrarSalasPexip()
  }

  async borrarSalasPexip() {
    for (const [index, sala] of this.usuariosNoValidos.entries()) {
      console.log(index);
      console.log(sala);
      try {
        const response = await fetch(
          'https://us-central1-the-campus-56b06.cloudfunctions.net/deleteSalaPexip?salaname=' +
            sala,
          {
            method: 'GET', // o 'DELETE' si es para borrar
          }
        );
        const data = await response.json();
        console.log(index);
        console.log('delete: ', sala);
      } catch (error) {
        console.log('ERROR------------', error);
      }
    }
  }

  descargarUsuariosColegia() {
    console.log('usuarios', this.listadoUsuariosColegia.length);
    this.excelService.exportAsExcelFile(
      this.listadoUsuariosColegia,
      'usuarios_thecampus'
    );
  }

  // borrarPorCodigo(){
  //   this.usuarios.forEach((uid,index)=>{
  //     console.log(index)
  //     console.log(uid)
  //     this.http
  //     .get<any>(
  //       'https://us-central1-the-campus-56b06.cloudfunctions.net/delUser',
  //       { params: new HttpParams().set('uid', uid) }
  //     )
  //     .subscribe((data) => {
  //       console.log(index)
  //       console.log("delete: ", data)
  //     });
  //   });
  // }

  // deleteUsers() {
  //   this.uids.forEach((uid, index) => {
  //     console.log('Id a borrar:', uid);
  //     this.http
  //       .get<any>(
  //         'https://us-central1-the-campus-56b06.cloudfunctions.net/delUser',
  //         {
  //           params: new HttpParams().set('uid', uid),
  //           responseType: 'text' as 'json',
  //         }
  //       )
  //       .subscribe((data) => {
  //         console.log(index);
  //         console.log('delete: ', data);
  //         console.log('delete: ', uid);
  //       });
  //   });
  // }
  deleteUsersAuth() {
    this.http
      .post<any>(
        'https://us-central1-the-campus-56b06.cloudfunctions.net/deleteUsersWithAIS',
        {} // body vacío
      )
      .subscribe({
        next: (data) => {
          console.log('Usuarios eliminados:', data);
        },
        error: (err) => {
          console.error('Error al eliminar usuarios:', err);
        },
      });
  }

  deleteUsers() {
    const body = {
      uids: this.uids,
    };

    this.http
      .post<any>(
        'https://us-central1-the-campus-56b06.cloudfunctions.net/deleteUsers',
        body,
        {
          responseType: 'text' as 'json',
        }
      )
      .subscribe({
        next: (data) => {
          console.log('Usuarios eliminados:', data);
        },
        error: (err) => {
          console.error('Error al eliminar usuarios:', err);
        },
      });
  }

  // deleteEmail() {
  //   console.log('--Comenzamos--' + this.correos.length);

  //   if (this.numerofinal > this.correos.length) {
  //     this.numerofinal = this.correos.length;
  //   }
  //   console.log('NUMERO inicial ' + this.numeroinicial);
  //   console.log('NUMERO FINAL ' + this.numerofinal);
  //   for (let index = this.numeroinicial; index < this.numerofinal; index++) {
  //     const correo = this.correos[index];
  //     let contador = index + 1;
  //     // console.log(contador + '. ' + correo);
  //     // this.eliminarUsuario(correo)
  //     //   .then((res) => {
  //     //     console.log('eliminado', res);
  //     //     console.log(contador);
  //     //   })
  //     //   .catch(() => {
  //     //     console.log('ya estaba eliminado');
  //     //     console.log(contador);
  //     //   });
  //   }
  //   console.log('--Terminamos--');
  // }

  // async eliminarUsuario(email) {
  //   console.log('borrando: ' + email);
  //   try {
  //     return await this.http
  //       .get<any>(
  //         'https://us-central1-the-campus-56b06.cloudfunctions.net/delUserEmail',
  //         { params: new HttpParams().set('email', email) }
  //       )
  //       .subscribe((element) => {
  //         console.log('me devuelven esto', element);
  //       });
  //   } catch (error) {console.log("Error al borrar: " + email)}
  // }

  buscarCursos() {
    this.colegiosService
      .getColegioByIdNow('qKQCtDaQ5GRP8wsJVVsi')
      .subscribe((cole: any) => {
        // console.log(cole)
        this.cursos = cole.data().courses;
        console.log(this.cursos.length);
        this.verCursos();
        this.buscarClases();
        // this.eliminarCursos();
      });
  }

  eliminarCursos() {
    for (let index = 0; index < this.cursos.length; index++) {
      const curso = this.cursos[index];
      console.log('ID curso: ' + curso);
      // this.eliminarCurso(curso);
    }
  }

  verCursos() {
    for (let index = 0; index < this.cursos.length; index++) {
      const curso = this.cursos[index];
      console.log('ID curso: ' + curso);
    }
  }

  buscarClases() {
    for (let index = 0; index < this.cursos.length; index++) {
      const curso = this.cursos[index];
      this.cursosService.getCursosById(curso).subscribe((cursodato: any) => {
        this.clases = cursodato.payload.data().classes;
        this.verClases(this.cursos[index]);
      });
    }

    // this.cursosService.getCursosById("0CuUbDmBjWs1cUwGQBSE").subscribe((cursodato: any) => {
    //   this.clases = cursodato.payload.data().classes;
    //   this.verClases("0CuUbDmBjWs1cUwGQBSE");
    // });

    // this.eliminarCurso("0CuUbDmBjWs1cUwGQBSE");
  }
  verClases(curso) {
    console.log('clases totales: ' + this.clases.length);
    console.log('CURSO------->' + curso);
    for (let index = 0; index < this.clases.length; index++) {
      try {
        const clase = this.clases[index];
        let contador = index + 1;
        console.log(contador + '. ' + clase);
        // this.eliminarClase(clase)
      } catch (error) {
        console.error('---- ¡¡¡ Hubo fallo !!! ----' + error);
      }
    }
  }
  // pruebaEliminarClase(){
  //   this.eliminarClase("dlasjdlaskiasidua98sc12uu")
  // }

  eliminarClase(clase) {
    this.clasesService
      .DeleteClass(clase)
      .then(() => {
        console.log('ELIMINADA LA CLASE: ' + clase);
      })
      .catch((error) => {
        console.error(
          '---- ¡¡¡ Hubo fallo al borrar la clase !!! ----' + error
        );
      });
  }

  eliminarCurso(curso) {
    this.cursosService
      .deleteCurso(curso)
      .then(() => {
        console.log('ELIMINADO EL CURSO: ' + curso);
      })
      .catch((error) => {
        console.error(
          '---- ¡¡¡ Hubo fallo al borrar el curso !!! ----' + error
        );
      });
  }

  estanUsuariosCodigo() {
    for (let index = 0; index < this.codigos.length; index++) {
      const codigo = this.codigos[index];
      this.usuariosService.getUserCodigo(codigo).subscribe((dato) => {
        // dato.docs[0].exists
        if (dato.size == 0) {
          console.log(index + ' ' + codigo);
          this.codigosNoEstan.push(codigo);
        } else {
        }
      });
    }
  }

  cambiarEmailYUsuarioBBDD() {
    let emailsAnt = [];

    let emailsNuevo = [];

    for (let index = 0; index < emailsAnt.length; index++) {
      const emailAntiguo = emailsAnt[index];
      const emailNuevo = emailsNuevo[index];
      this.usuariosService
        .getUserByEmail(emailAntiguo)
        .subscribe((usuarios: any) => {
          if (usuarios.docs.length > 0) {
            let datos = usuarios.docs[0].data();
            let id = usuarios.docs[0].id;
            datos.email = emailNuevo;
            datos.usuario = emailNuevo;
            this.usuariosService
              .editUser(datos, id)
              .then()
              .catch((error) => {
                console.log('Error--- con ' + emailAntiguo, error);
              });
          }
        });
    }
  }

  cogerUids() {
    for (let index = 0; index < this.codigos.length; index++) {
      const codigo = this.codigos[index];
      this.usuariosService.getUserCodigo(codigo).subscribe((dato: any) => {
        // dato.docs[0].exists
        if (dato.empty) {
          console.log(index + ' ' + codigo);
          this.codigosNoEstan.push(codigo);
        } else {
          console.log('usuario', dato.docs[0].data().username);
          var valor = {
            uid: dato.docs[0].data().uid,
            usuario: dato.docs[0].data().username,
          };
          console.log('valor', valor);
          this.usuariosUid.push(valor);
        }
      });
    }
  }

  descargarUid() {
    this.excelService.exportAsExcelFile(this.usuariosUid, 'user_uids');
  }

  crearLicencias() {
    for (let index = 0; index < this.licencias.length; index++) {
      const element = this.licencias[index];
      var licen = {
        codigo: element,
        colegio: 'GicCEClIcYiFhACkwAll',
        usado: false,
      };
      this.licenciasService.createdLicencia(licen).then((da) => {
        console.log('licencia', licen);
      });
    }
  }

  loginInSAMLcharterschoolit() {
    const provider = new auth.SAMLAuthProvider('saml.charterschoolit');
    this.authenticationService
      .loginWithSAML(provider)
      .then((userCredential) => {
        // console.log("Login correcto" , userCredential);
        console.log(userCredential.user.uid);

        var samlProfile = userCredential.additionalUserInfo.profile;
        var text = JSON.stringify(samlProfile);

        this.usuariosService
          .getUserById(userCredential.user.uid)
          .subscribe((ddata) => {
            if (ddata[0]) {
              var userdata: any = ddata[0].payload.doc.data();
              this.usuariosService.setUserinfo(ddata[0]);

              if (
                userdata.role === 'student' ||
                userdata.role === 'teacher' ||
                userdata.role === 'director' ||
                userdata.role === 'supervisor'
              ) {
                this.router.navigate(['dashboard']);
              } else if (userdata.role === 'admin') {
                this.router.navigate(['admin']);
              }
            } else {
              console.log('no hay usuario');
            }
          });

        //userCredential.user.getIdToken()
      })
      .catch((error) => {
        console.log('Hubo este error: ' + error);
      });

    // volver a autenticar a un usuario con reauthenticateWithRedirect() y reauthenticateWithPopup() , que se puede usar para recuperar credenciales nuevas para operaciones confidenciales que requieren un inicio de sesión reciente.
  }
}

